import { render } from "./EditWizard.vue?vue&type=template&id=770113c4"
import script from "./EditWizard.vue?vue&type=script&lang=js"
export * from "./EditWizard.vue?vue&type=script&lang=js"

import "./EditWizard.vue?vue&type=style&index=0&id=770113c4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__